function waitForCustomerReferralLoaded(a, b = 100) {
  const c = setInterval(function () {
    "undefined" != typeof uppromoteCustomerReferral && (a(), clearInterval(c));
  }, b);
  setTimeout(function () {
    clearInterval(c);
  }, 5e3);
}
function waitElementLoaded(a, b, c = 100) {
  const d = setInterval(function () {
    const c = document.querySelector(a);
    c && (b(), clearInterval(d));
  }, c);
  setTimeout(function () {
    clearInterval(d);
  }, 5e3);
}

waitElementLoaded(`.sca_aff_customer_invite_error`, function () {
  waitForCustomerReferralLoaded(function () {
    if(document.querySelector('.sca_aff_customer_invite_error').style.display == 'block'){
      document.querySelector('.sca_aff_customer_invite_error').innerHTML = 'Bitte gib eine gültige E-Mail Adresse an';
    }
  });
});

waitElementLoaded(`.sca_aff_customer_refer_invite_button`, function () {
  waitForCustomerReferralLoaded(function () {
    document.querySelector('.sca_aff_customer_refer_invite_button').onclick = function () {
        if(document.querySelector('.sca_aff_customer_invite_error').style.display == 'block'){
          document.querySelector('.sca_aff_customer_invite_error').innerHTML = 'Bitte gib eine gültige E-Mail Adresse an';
        }
    }
  });
});